
<template>
	<div class="user_memorandum_menus " v-if="menus.length > 0">
		<menu_item v-bind:item="itm" :key="itm.id" v-for="itm in menus"></menu_item>
	</div>
</template>

<script>
 
	import { TweenMax } from 'greensock';
	import Menu_item from "./menu_item.vue";

    export default {
        components : {
			Menu_item,
        },
        name: "imcdashboard",
        data() {
            return {
                menus  : [],
                is_show : false,
            }
        },

        created() {
            this.getMenus();
        },

        mounted() {

        },
        methods: {
            async getMenus() {
                await axios.get('/docs/internal/api/mem_menu').then(({data}) => {
                    if (data.status == "operation_success") {
                        this.menus = data.data;
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err:err.message ,type:"danger",title:err.name})
                });
            },
        },
        computed: {

        },
    }
</script>

<style scoped>
	.slide-fade-enter-active {
		transition: all .2s ease;
	}
	.slide-fade-leave-active {
		transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter, .slide-fade-leave-to
		/* .slide-fade-leave-active до версии 2.1.8 */ {
		transform: translateX(10px);
		opacity: 0;
	}
</style>
